export const locale = {
  lang: 'nl',
  data: {
    'ALERTS':{
      'OK':'OK'
    },
    'CIERRE': {
      'CARGANDO': 'Lenen van gegevens',
      'CARGANDOCORREO': 'Wacht even, alsjeblieft...',
      'LABEL1': 'Deelnamepercentage',
      'LABEL2': 'Zie vooruitgang',
      'LABEL3': 'Onderzoek voltooid',
      'LABEL4': 'Zie resultaat',
      'LABEL5': 'De herinneringen zijn verstuurd',
      'LABEL6': 'U heeft vandaag al een e-mail gestuurd',
      'LABEL7': 'U kunt alleen herinneringen sturen na de dag van de lancering',
      'LABEL8': 'Wacht even......',
      'LABEL9': 'Resterende dagen',
      'BTN_CIERRE': 'Sluiten',
      'ALERT':{
        'MESSAGE': 'Bevestigt u dat u de verwachte enquête afsluit?',
        'BTN_CONFIRM': 'Ja',
        'BTN_CANCEL': 'Nee',
        'OK': 'OK',
      },
      'ALERT_RE':{
        'MESSAGE': 'Weet je zeker dat je de herinneringen wilt sturen?',
        'BTN_CONFIRM': 'Ja',
        'BTN_CANCEL': 'Nee',
        'OK': 'OK',
      },
      'LINK': 'Ga naar de volgende link om de huidige voortgang van de enquête te bekijken',
      'LINKENCUESTA': 'Genereert de link om de huidige voortgang van het onderzoek te bekijken',
      'ACTIONS':{
        'TITULO': 'Acties',
        'TITULO_ACTUALIZADO': 'Herinneringen',
        'TITULO_ACCESS': 'Toegang tot de enquête',
        'WANNADO': 'Wat wil je doen?',
        'TITULO_VIRSMS': 'Virtuele SMS-portal',
        'TITULO_MYCODE': 'GetMyCode.culturalgo.com portal',
        'TITULO_BTNMYCODE': 'Ga naar het GetMyCode-portaal',
      },
      'COMPLETO':{
        'TAG': 'Het onderzoek is met succes afgerond',
        'CARDTIT': 'Resultaten zoeken',
        'LINK': 'Ga naar de volgende link om de verkregen resultaten in de enquête te bekijken',
      },
      'PORTAL':{
        'LABEL01': 'Telportaal',
        'LABEL02': 'Toegangscode genereren',

      },
      'PULSE':{
        /// Survey advancement
        'LABELPRO': 'Voortgang van de enquête',
        'LINKEN': 'Enquêtekoppeling',
        'LINKRES': 'Linkresultaat',
        'ENCUESTANOENVIADA': 'Er is nog geen Pulse Check-onderzoek vrijgegeven',
      },
      'CIERRE':{
        'BCONTEOS': 'Telportaal',
        'BACCESO': 'Toegangscode genereren',
        'LINKPORTAL': 'Kopieer de toegangslink naar het telportaal',
        'COPYLINK': 'Gekopieerd naar uw klembord',
        'REMANDER': 'Herinneringen',
        'REMANDERC2': 'Herinnering aan mensen die de enquête niet hebben afgerond',
        'REMANDER1':'Herinneringen aan mensen die uw enquête nog niet hebben ingevoerd',
        'REMANDER2':'Herinneringen aan mensen die zijn begonnen en nog steeds niet eindigen',
        'REMANDER_TURQUIA': 'Stuur herinneringen aan alle deelnemers',
        'GETURLSURV_1': 'Genereer de link van de enquêteaanbieder',
        'GETURLSURV_2': 'De koppeling voor de aanbieder van toegang tot de enquête is gegenereerd, u kunt deze nu kopiëren door op dezelfde knop te klikken',
        'GETURLSURV_3': 'Kopieer de link van de enquêteprovider',
        'ASIGUSERDEMO': 'Een wachtwoord toewijzen',
      },
      'MOD_TEX_SEND_RECO':'E-mail verzenden...',

    },
  }
};
